import React from 'react';
import { useNavigate } from 'react-router-dom';

type Button = {
  title: string;
  location?: string;
  type: 'link' | 'primary' | 'secondary' | 'modal';
};

type Props = {
  title: string;
  buttons?: Button[];
  onClick?: (button: Button) => void;
};

export const PageHeader = ({ title, buttons = [], onClick }: Props): JSX.Element => {
  const navigate = useNavigate();

  const handleButtonClick = (button: Button): void => {
    if (onClick) {
      onClick(button);
    }
    if (button.location) {
      navigate(button.location);
    }
  };

  return (
    <div className="page-header">
      <h2>{title}</h2>
      {buttons.length > 0 && (
        <div className="page-header-buttons">
          {buttons.map((button) => (
            <span
              className={`page-header-btn-${button.type}`}
              key={button.title}
              onClick={(): void => handleButtonClick(button)}>
              {button.title}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
